import Hero from "./Hero";

export { default as BouncingArrow } from "./BouncingArrow";
export { default as HeroText } from "./HeroText";
export { default as HeroIcon } from "./HeroIcon";

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero/index.js